'use strict';

require('./index.less');


/*****************
 ** WEBPACK FOOTER
 ** ./components/locale-provider/style/index.tsx
 ** module id = 312
 ** module chunks = 0
 **/